import { config } from '../config/env'
import { ApiError } from './api'

export interface ZipLookupResponse {
  zipCode: string
  street: string
  neighborhood: string
  city: string
  state: string
  complement?: string
  latitude?: string
  longitude?: string
}

export type ZipLookupOptions = {
  publicOnly?: boolean
}

export async function lookupZipCode(
  zipCode: string,
  options?: ZipLookupOptions
): Promise<ZipLookupResponse> {
  const normalized = zipCode.replace(/\D/g, '')
  const base = String(config.api.baseUrl ?? '')
    .trim()
    .replace(/\/+$/, '')
  const token =
    typeof localStorage !== 'undefined' ? localStorage.getItem('accessToken') : null
  const usePublic = options?.publicOnly === true || !token
  const path = usePublic
    ? `${base}/public/cep/${normalized}`
    : `${base}/location/lookup-zip/${normalized}`
  const headers: HeadersInit = { Accept: 'application/json' }
  if (!usePublic && token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  const res = await fetch(path, { headers, credentials: 'omit' })
  if (!res.ok) {
    let message = 'CEP não encontrado.'
    try {
      const err = (await res.json()) as { message?: string | string[] }
      const m = err.message
      if (typeof m === 'string') message = m
      else if (Array.isArray(m) && m[0]) message = m[0]
    } catch {
      message = res.status >= 500 ? 'Serviço de CEP indisponível.' : message
    }
    throw new ApiError({ message, status: res.status })
  }
  return res.json() as Promise<ZipLookupResponse>
}
